import { IsString, IsOptional } from 'class-validator';

export default class ExitNode {
  id: string;

  @IsString()
  @IsOptional()
  description: string;

  // temporary commented it
  // we should allow to persist empty selection for Exit & Voicemail nodes ( supernova allows optional selection -> only UI fix )
  // ch - https://app.clubhouse.io/gladly/story/82007/selection-ivr-node-property-must-be-optional
  // @IsString()
  // @IsNotEmpty({ message: 'Name should not be empty' })
  selection: string;

  @IsOptional()
  number: string;
}
